/**
 * @generated SignedSource<<0e7b2cde10f2cf86efd17778d9f22686>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArticleLinkRecord_content$data = {
  readonly articleLink: {
    readonly topic: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly linkText: string | null | undefined;
  readonly " $fragmentType": "ArticleLinkRecord_content";
};
export type ArticleLinkRecord_content$key = {
  readonly " $data"?: ArticleLinkRecord_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"ArticleLinkRecord_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ArticleLinkRecord_content",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpCenterArticleRecord",
      "kind": "LinkedField",
      "name": "articleLink",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "HelpCenterTopicRecord",
          "kind": "LinkedField",
          "name": "topic",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ArticleLinkRecord",
  "abstractKey": null
};
})();

(node as any).hash = "d7721712be6a9558e1c6169f222521b6";

export default node;
